// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3HDpt","imageUploader":"EGiftCard_imageUploader__6IXnE"};